var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: { title: _vm.title, size: "lg", "hide-ok": "", "hide-cancel": "" },
      on: {
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("Resend", {
        attrs: {
          type: _vm.type,
          "resend-function": _vm.resendFunction,
          "change-function": _vm.changeFunction,
          phone: _vm.phone
        },
        on: {
          success: function($event) {
            return _vm.$emit("success")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }